export enum ClaimResult {
  Ok = 'Ok',
  ClaimAlreadyUsed = 'ClaimAlreadyUsed',
  UserAlreadyClaimedSameUser = 'UserAlreadyClaimedSameUser',
  UserAlreadyClaimedOtherUser = 'UserAlreadyClaimedOtherUser',
}
